import { Component, effect, ElementRef, input, signal, viewChild } from "@angular/core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: 'wf-alert',
  standalone: true,
  imports: [
    FontAwesomeModule,
  ],
  styleUrl: 'alert.component.css',
  template: `
    @if (static() || alert()) {
      <div class="alert alert-{{ level() }}" [attr.role]="alert() ? 'alert' : undefined">
        <div class="alert-content">
          <ng-content/>
        </div>
        @if (alert()) {
          <button
            class="dismiss-button"
            #dismissButton
            (click)="dismiss()"
            aria-label="Dismiss alert"
          >
            <fa-icon [icon]="closeIcon"/>
          </button>
        }
      </div>
    }
  `,
})
export class AlertComponent {
  // If this alert should be shown 100% of the time
  readonly static = input(false);
  readonly level = input<"info" | "warning" | "danger">("info");

  // if this alert should dynamically shown/dismissed, such as an error message
  protected alert = signal(false);

  protected closeIcon = faXmark;

  protected readonly dismissButton = viewChild<ElementRef<HTMLButtonElement>>('dismissButton');
  protected readonly dissmissButtonFocusEffect = effect(
    () => {
      const button = this.dismissButton();
      // whenever the button appears in the dom it should be focused
      if (button) {
        button.nativeElement.focus();
      }
    }
  );

  show() {
    this.alert.set(true);
  }

  dismiss() {
    this.alert.set(false);
  }
}
